class ProductOffers extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupVariables();
    this.setupEvents();
    this.init();
  }

  setupVariables() {
    this.productOffers = this.querySelectorAll('product-offer');
  }

  setupEvents() {
    this.productOffers.forEach((element) => {
      element.addEventListener("click", this.onProductOfferClick.bind(this));
    });
  }

  init() {
    
  }

  onProductOfferClick(event) {
    const target = event.target;
    const currentTarget = event.currentTarget;
    if (target.closest('.card-product-form') !== null) return;
    this.toggleSelectedProduct(currentTarget);
    currentTarget.onVariantChanged();
  }

  toggleSelectedProduct(target) {
    this.productOffers.forEach((element) => {
      element.classList.remove('selected');
    });

    target.classList.add('selected');
  }
}
customElements.define("product-offers", ProductOffers);

class ProductOffer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupVariables();
    this.setupEvents();
  }

  setupVariables() {
    this.description = this.querySelector(".product-item-meta__description");
    this.showMoreButton = this.querySelector(".product-item-meta__description-show-more");
    this.mainProductForm = this.closest('.shopify-section').querySelector('.product__info > .product-form > .product-form__buy-buttons > form');
  }

  setupEvents() {
    if (this.showMoreButton !== null) this.showMoreButton.addEventListener("click", this.showMore.bind(this));
    this.addEventListener("variant:changed", this.onVariantChanged.bind(this));
  }

  showMore() {
    this.description.classList.toggle("expanded");
    
    if (this.description.classList.contains('expanded')) {
      this.showMoreButton.textContent = this.showMoreButton.dataset.openedText;
    } else {
      this.showMoreButton.textContent = this.showMoreButton.dataset.initialText;
    }
  }

  onVariantChanged(event) {
    console.log('product offer variant changed');
    if (this.mainProductForm === null) return;
    const mainProductFormId = this.mainProductForm.querySelector('[name="id"]');
    const variantId = event?.detail.variant.id || this.variantId;
    if (mainProductFormId) mainProductFormId.value = variantId;
  }

  get productItem() {
    return this.querySelector('product-item');
  }

  get variantId() {
    return this.querySelector('[name="id"]').value;
  }
}
customElements.define("product-offer", ProductOffer);